import { Subject, merge } from "rxjs";
import { shareReplay } from "rxjs/operators";

export const codeTableCacheBuster$ = new Subject<void>();
export const listingCacheBuster$ = new Subject<void>();
export const listingOptionsCacheBuster$ = new Subject<void>();
export const bulkListingsCacheBuster$ = new Subject<void>();
export const searchResultsCacheBuster$ = merge(
	listingCacheBuster$.asObservable(),
	bulkListingsCacheBuster$.asObservable()
);

export const mediaCacheBuster$ = new Subject<void>();

export const validationCacheBuster$ = merge(
	listingCacheBuster$.asObservable(),
	mediaCacheBuster$.asObservable()
);

export const ownerCacheBuster$ = new Subject<void>();
export const memberCacheBuster$ = new Subject<void>();
export const loginCacheBuster$ = new Subject<void>();
export const officeCacheBuster$ = new Subject<void>();
export const countCacheBuster$ = merge(
	ownerCacheBuster$.asObservable(),
	memberCacheBuster$.asObservable(),
	loginCacheBuster$.asObservable(),
	officeCacheBuster$.asObservable()
).pipe(shareReplay({ bufferSize: 1, refCount: true }));
export const ownerMemberCacheBuster$ = merge(
	ownerCacheBuster$.asObservable(),
	memberCacheBuster$.asObservable()
).pipe(shareReplay({ bufferSize: 1, refCount: true }));
